import Initialiser from 'initialiser';
import { cloneDeep } from 'utils/immutable';

// ACTION TYPES
const OPEN_CALENDLY_MODAL = 'OPEN_CALENDLY_MODAL';
const CLOSE_CALENDLY_MODAL = 'CLOSE_CALENDLY_MODAL';

// SYNC ACTION CREATORS
export function openCalendlyModal(title, content, action) {
    return { type: OPEN_CALENDLY_MODAL, title, content, action };
}
export function closeCalendlyModal() {
    return { type: CLOSE_CALENDLY_MODAL };
}

// REDUCERS
export default function reducer(state = Initialiser.initialState.upload, action) {
    switch (action.type) {
        case OPEN_CALENDLY_MODAL:
            return cloneDeep({
                modalOpen: true,
                modalTitle: action.title,
                modalContent: action.content,
                modalAction: action.action,
            });
        case CLOSE_CALENDLY_MODAL:
            return cloneDeep({ modalOpen: false });
        default: {
            return state;
        }
    }
}
